import MDEditor from "@uiw/react-md-editor";

type RehypeRewrite = NonNullable<React.ComponentProps<typeof MDEditor.Markdown>["rehypeRewrite"]>;

// Replacement for the `linkTarget="_blank"` prop removed in react-markdown 9
export const openLinksInNewTab: RehypeRewrite = (node) => {
    if (node.type !== "element") return;

    if (node.properties) {
        for (const key of Object.keys(node.properties)) {
            if (/^on/i.test(key)) delete node.properties[key];
        }
    }

    if (node.tagName === "a") {
        node.properties = { ...node.properties, target: "_blank" };
    }
};
